import React from 'react';
import Table from '../../../../../components/form/table';
import { useTranslation } from 'react-i18next';
import {getPerfectDate} from '../../../../../utils/index'
import { TrashIcon } from '@heroicons/react/outline';

const AccessTable = ({ tableData, onItemDelete }) => {
  const {t} = useTranslation();

  const items = tableData.map(tableItem => {
    return (
      {
        id: tableItem.id,
        at: tableItem.attributes.at,
        access_token: tableItem.attributes.access_token_id,
        access_token_type: tableItem.attributes.access_token_type,
        status: tableItem.attributes.status
      }
    )
  });

  const columns = [
    {
      label: t('at'),
      prop: "at",
      labelClassName: "w-full lg:w-1/12",
      className: "w-full lg:w-1/12 flex-shrink-0",
      render: (row) => {
        return (
          <div className="flex items-center">
            {getPerfectDate(row.at)}
          </div>
        )
      }
    },
    {
      label: t('access_token'),
      prop: "access_token",
      labelClassName: "w-full lg:w-2/12",
      className: "w-full lg:w-2/12 flex-shrink-0",
      render: (row) => { 
        return (
          <>
            <div className="font-medium text-gray-900 truncate">
              {row.access_token}
            </div>
          </>
        )
      }
    },
    {
      label: t('access_token_type'),
      prop: "access_token",
      labelClassName: "w-full lg:w-3/12",
      className: "w-full lg:w-3/12 flex-shrink-0",
      render: (row) => { 
        return (
          <>
            <div className="font-medium text-gray-900 truncate">
              {t(`${row.access_token_type}_access`)}
            </div>
          </>
        )
      }
    },
    {
      label: t('status'),
      prop: "status",
      labelClassName: "w-full lg:w-4/12",
      className: "w-full lg:w-4/12 flex-shrink-0",
      render: (row) => { 
        return (
          <div className="flex items-center">
            {t(`access_status_${row.status}`)}
          </div>
        )
      }
    },
    {
      label: t('actions'),
      prop: "actions",
      labelClassName: "w-full lg:w-2/12 invisible",
      className: "w-full lg:w-2/12 flex-shrink-0",
      render: (row) => {
        return (
          <div className="flex space-x-2 justify-end">
            <button 
              onClick={() => onItemDelete(row.id)} 
              className="text-red-600 hover:text-red-900 cursor-pointer w-8 h-8 bg-pink-100 hover:bg-pink-200 flex items-center justify-center rounded-sm">
              <TrashIcon className="w-4 h-4"/>
            </button>
          </div>
        )
      }
    }
  ]

  return (
    <Table
      border={true}
      columns={columns}
      data={items}
    />
  );

};

export default AccessTable;
